import * as React from 'react';

import {
  createStyles,
  Drawer,
  Hidden,
  SwipeableDrawer,
  Theme,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

import logo from '../../../../assets/images/logo.svg';

import Link from '../../../modules/Link';
import renderNavItems from './renderNavItems';

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    paper: {
      width: 240,
      backgroundColor: '#fff',
    },
    toolbar: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: `${spacing(2)}px ${spacing(3)}px 0`,
      marginBottom: spacing(2),
    },
    logoLink: {
      display: 'block',
      marginBottom: spacing(1),
    },
    logo: {
      width: '163px',
      maxWidth: '100%',
      maxHeight: '50px',
      height: 'auto',
      display: 'block',
    },
    blurb: {
      margin: `${spacing(2)}px ${spacing(3)}px`,
      paddingTop: spacing(2),
      borderTop: `1px solid ${palette.grey[300]}`,
      lineHeight: 1.5,
      letterSpacing: 0,
      '& strong, & a': {
        color: palette.primary.main,
      },
      '& strong': {
        fontSize: '1rem',
      },
    },
  });

interface INavDrawerProps extends WithStyles<typeof styles> {
  className: string;
  disablePermanent: boolean;
  mobileOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  activePage: string;
  activePath: string;
}

const NavDrawer: React.FunctionComponent<INavDrawerProps> = ({
  classes,
  className,
  disablePermanent,
  mobileOpen,
  onClose,
  onOpen,
  activePage,
  activePath,
}) => {
  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <Link underline="none" href="/" className={classes.logoLink}>
          <img src={logo} alt="Unifi Design System" className={classes.logo} />
        </Link>
      </div>
      {renderNavItems({ activePage, activePath })}
    </div>
  );

  return (
    <nav aria-label="primary" className={className}>
      <Hidden mdUp={!disablePermanent} implementation="js">
        <SwipeableDrawer
          classes={{
            paper: classes.paper,
          }}
          variant="temporary"
          open={mobileOpen}
          onOpen={onOpen}
          onClose={onClose}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {drawer}
        </SwipeableDrawer>
      </Hidden>
      {disablePermanent ? null : (
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.paper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      )}
    </nav>
  );
};

export default withStyles(styles)(NavDrawer);
